
import { defineComponent, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import logout from '@/http/logout.api';

export default defineComponent({
  name: 'CxLogout',
  setup() {
    const router = useRouter();

    onMounted(async () => {
      await logout();
      router.replace('/login');
    });
  }
});
